import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import {
  AppBar,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  Toolbar,
} from '@mui/material';

import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';

import NavLinkLayout from './NavLinkLayout';
import { TypoPoppins } from '../../../Components/Typo';
import useHandleLogout from '../../../Hooks/useHandleLogout';
import { COLORS } from '../../../Constant/COLORS';

const MobileNavigationLayout = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const navigate = useNavigate();
  const handleLogout = useHandleLogout();

  const onLogoutClick = async () => {
    setIsDrawerOpen(false);
    await handleLogout();
    navigate('/professional/login');
  };

  return (
    <>
      <AppBar position='static' color='blue' elevation={0}>
        <Toolbar>
          <TypoPoppins variant='h4' fontWeight={600} my={1.5} color='#fff'>
            Profile
          </TypoPoppins>
          <IconButton sx={{ ml: 'auto' }} onClick={() => setIsDrawerOpen(true)}>
            <MenuIcon htmlColor='white' />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        open={isDrawerOpen}
        PaperProps={{ sx: { p: 3, pl: 5 } }}
        onClose={() => setIsDrawerOpen(false)}
      >
        <List disablePadding sx={{ whiteSpace: 'nowrap', mt: 3, ml: -2 }}>
          <NavLinkLayout to='my-details'>My Details</NavLinkLayout>
          <NavLinkLayout to='profile'>Profile</NavLinkLayout>
          <NavLinkLayout to='password'>Password</NavLinkLayout>
          <NavLinkLayout to='job-requests/response'>Job Requests</NavLinkLayout>
          <NavLinkLayout to='job-information/in-complete'>
            Job Information
          </NavLinkLayout>
          <NavLinkLayout to='review-manage'>Review Manage</NavLinkLayout>
          <NavLinkLayout to='account-details'>Account Details</NavLinkLayout>

          <ListItem disableGutters disablePadding sx={{ mt: 2 }}>
            <ListItemButton
              onClick={onLogoutClick}
              sx={{ color: COLORS.blue, borderRadius: '4px', fontWeight: 600 }}
            >
              <LogoutIcon fontSize='small' sx={{ mr: 1 }} />
              Logout
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>
    </>
  );
};

export default MobileNavigationLayout;
